import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { ProjectsDocumentType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { PROJECTS_DOCUMENTS } from "../../utils/constants";

export const createProjectsDocument = async (data: ProjectsDocumentType) => await post<ProjectsDocumentType, string>(PROJECTS_DOCUMENTS, data);
export const updateProjectsDocument = async (data: ProjectsDocumentType) => await put<ProjectsDocumentType, string>(PROJECTS_DOCUMENTS, data);

export const getProjectsDocuments = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100', 
        ...(data?.IdProject ? { IdProject: data.IdProject  } : {}),
    });
    const url = `${PROJECTS_DOCUMENTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<ProjectsDocumentType>>(url);
};
